const en = {
    title: 'Wallet Guide',
    baseTitle: 'Basic knowledge',
    baseContent1: 'What Is Blockchain?',
    baseUrl1: 'https://tphelp.gitbook.io/en/blockchain-basics/blockchain-definition',
    baseContent2: 'What Is a Decentralized Wallet?',
    baseUrl2: 'https://tphelp.gitbook.io/en/blockchain-basics/what-is-a-decentralised-wallet',
    baseContent3: 'What Is the Private Key, Mnemonic & Password?',
    baseUrl3: 'https://tphelp.gitbook.io/en/blockchain-basics/what-is-the-private-key-mnemonic-and-wallet-password',
    baseContent4: 'What Is the Miner Fee?',
    baseUrl4: 'https://tphelp.gitbook.io/en/blockchain-basics/what-is-the-miner-fee',
    baseContent5: 'What is a hardware wallet?',
    baseUrl5: 'https://help.tokenpocket.pro/en/blockchain-basics/Hardware-Wallet',
    baseContent6: 'What is a cold wallet?',
    baseUrl6: 'https://help.tokenpocket.pro/en/blockchain-basics/Cold-Wallet',
    baseContent7: 'What is a hot wallet?',
    baseUrl7: 'https://help.tokenpocket.pro/en/blockchain-basics/Hot-Wallet',
    baseContent8: 'What is a watch wallet?',
    baseUrl8: 'https://help.tokenpocket.pro/en/blockchain-basics/Watch-the-wallet',
    baseContent9: 'What is a multisig wallet?',
    baseUrl9: 'https://help.tokenpocket.pro/en/blockchain-basics/Multisig',
    baseContent10: 'What is an extension wallet?',
    baseUrl10: 'https://help.tokenpocket.pro/en/blockchain-basics/Plug-in',
    safeTitle: 'Security Knowledge',
    safeTitle1: 'Common Fraud Cases',
    safeTitle2: 'Protective Measures',
    safeContent1: 'Fake Airdrop Scam',
    safeUrl1: 'https://tphelp.gitbook.io/en/security-knowledge/common-fraud-cases/fake-airdrop-giveaway-scam',
    safeContent2: 'Fake App Scam',
    safeUrl2: 'https://tphelp.gitbook.io/en/security-knowledge/common-fraud-cases/phishing-app-scam',
    safeContent3: 'Phishing Website Scam',
    safeUrl3: 'https://tphelp.gitbook.io/en/security-knowledge/common-fraud-cases/phishing-website-scam',
    safeContent4: 'Fake Token Scam',
    safeUrl4: 'https://tphelp.gitbook.io/en/security-knowledge/common-fraud-cases/fake-token-scam',
    safeContent5: 'Fake Customer Service Scam',
    safeUrl5: 'https://tphelp.gitbook.io/en/security-knowledge/common-fraud-cases/fake-customer-service-scam',
    safeContent6: 'Fake QR Code Scam',
    safeUrl6: 'https://tphelp.gitbook.io/en/security-knowledge/common-fraud-cases/fake-qr-code-scam',
    safeContent7: 'Application Approve Scam',
    safeUrl7: 'https://tphelp.gitbook.io/en/security-knowledge/common-fraud-cases/dapp-approval-scam',
    safeContent8: 'Free Recovery Phrase Scam',
    safeUrl8: 'https://help.tokenpocket.pro/en/security-knowledge/common-fraud-cases/tron-phishing-wallet',
    safeContent9: '"0 USDT" transfer scam',
    safeUrl9: 'https://help.tokenpocket.pro/en/security-knowledge/common-fraud-cases/zero-transfer',
    safeContent10: '"Phishing" address scam',
    safeUrl10: 'https://help.tokenpocket.pro/en/security-knowledge/common-fraud-cases/pretender',
    safeContent11: 'Assets Theft Prevention ',
    safeUrl11: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/theft-prevention',
    safeContent12: 'Assets Loss Prevention',
    safeUrl12: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/loss-prevention',
    safeContent13: 'Approval Detector Use Guide',
    safeUrl13: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/TP-Approve',
    safeContent14: 'Token Security Detection Use Guide',
    safeUrl14: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/Token-Detection',
    safeContent15: 'Verify the real TokenPocket (Download from official web)',
    safeUrl15: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/verify',
    safeContent16: 'Verify the real TokenPocket (Download from Google Play)',
    safeUrl16: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/verify-android',
    safeContent17: 'Hide small transaction records',
    safeUrl17: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/hide',
    DeFiTitle: 'DEX Tutorials',
    DeFiTitle1: 'How to Trade on DEX?',
    DeFiTitle2: 'Others',
    DeFiContent1: 'What Is DeFi?',
    DeFiUrl1: 'https://tphelp.gitbook.io/en/defi-tutorial/what-is-defi',
    DeFiContent2: 'What Is a Decentralized Exchange (DEX)?',
    DeFiUrl2: 'https://tphelp.gitbook.io/en/defi-tutorial/what-is-dex',
    DeFiContent3: 'Transit 2.0 Guide (All Chains)',
    DeFiUrl3: 'https://tphelp.gitbook.io/en/defi-tutorial/how-to-trade-on-dex/tutorial-for-xswap-2.0',
    DeFiContent4: 'Polygon (Matic) Guide',
    DeFiUrl4: 'https://tphelp.gitbook.io/en/defi-tutorial/how-to-trade-on-dex/polygon-matic-use-guide',
    DeFiContent5: 'Uniswap (Ethereum) Guide',
    DeFiUrl5: 'https://tphelp.gitbook.io/en/defi-tutorial/how-to-trade-on-dex/uniswap-ethereum',
    DeFiContent6: 'PancakeSwap (BSC) Guide',
    DeFiUrl6: 'https://tphelp.gitbook.io/en/defi-tutorial/how-to-trade-on-dex/pancakeswap-bsc',
    DeFiContent7: 'MDEX (HECO) Guide',
    DeFiUrl7: 'https://tphelp.gitbook.io/en/defi-tutorial/how-to-trade-on-dex/mdex-on-heco-guide',
    DeFiContent8: 'JustSwap (TRON) Guide',
    DeFiUrl8: 'https://tphelp.gitbook.io/en/defi-tutorial/how-to-trade-on-dex/justswap-on-tron-gudie',
    DeFiContent9: 'PuddingSwap (HSC) Guide',
    DeFiUrl9: 'https://tphelp.gitbook.io/en/defi-tutorial/how-to-trade-on-dex/puddingswap-on-hsc-guide',
    DeFiContent10: 'SushiSwap（OKEX）Guide',
    DeFiUrl10: 'https://tphelp.gitbook.io/en/defi-tutorial/how-to-trade-on-dex/sushiswap-on-okchain-guide',
    DeFiContent11: 'How to Submit DApps?',
    DeFiUrl11: 'https://app.gitbook.com/@tphelp/s/en/defi-tutorial/how-to-submit-dapps',
    normalTitle: 'FAQ',
    normalContent1: 'No direct transfer between different public chains.',
    normalUrl1: 'https://tphelp.gitbook.io/en/transfer-faq/about-public-chain-transfer',
    normalContent2: '[Withdraw assets] from Exchange to Wallet has not arrived',
    normalUrl2: 'https://tphelp.gitbook.io/en/transfer-faq/why-did-i-not-receive-my-funds-from-the-exchange-to-the-wallet',
    normalContent3: '[Deposit assets] from Wallet to Exchange has not arrived',
    normalUrl3: 'https://tphelp.gitbook.io/en/transfer-faq/why-did-i-not-receive-my-funds-from-the-wallet-to-the-exchange',
    normalContent4: 'What should I do if I transfer my assets to the contract address? ',
    normalUrl4: 'https://tphelp.gitbook.io/en/transfer-faq/why-cant-i-transfer-my-assets-to-the-contract-address',
    normalContent5: 'Why does the transfer always keep pending status?',
    normalUrl5: 'https://tphelp.gitbook.io/en/transfer-faq/why-does-the-transfer-always-keep-pending-status',
    normalContent6: 'Why can\'t I get my funds back when the transfer was failed?',
    normalUrl6: 'https://tphelp.gitbook.io/en/transfer-faq/why-cant-i-get-my-funds-back-when-the-transfer-was-failed',
    tokenTitle: 'Token Management',
    tokenTitle1: 'Others',
    tokenContent1: 'How to Search Tokens?',
    tokenUrl1: 'https://tphelp.gitbook.io/en/token-management/how-to-search-and-add-tokens',
    tokenContent2: 'How to Add Tokens?',
    tokenUrl2: 'https://tphelp.gitbook.io/en/token-management/how-to-add-tokens',
    tokenContent3: 'How to Delete Tokens?',
    tokenUrl3: 'https://tphelp.gitbook.io/en/token-management/how-to-delete-tokens',
    tokenContent4: 'How to Receive Tokens?',
    tokenUrl4: 'https://tphelp.gitbook.io/en/transfer-tutorial/how-to-receive-my-assets',
    tokenContent5: 'How to Submit Tokens?',
    tokenUrl5: 'https://tphelp.gitbook.io/en/token-management/how-to-submit-a-token',
    walletTitle: 'Wallet Management',
    walletContent1: 'How to Create a Wallet?',
    walletUrl1: 'https://tphelp.gitbook.io/en/wallet-management/how-to-create-a-wallet',
    walletContent2: 'How to Import a Wallet?',
    walletUrl2: 'https://tphelp.gitbook.io/en/wallet-management/how-to-import-a-wallet',
    walletContent3: 'How to Manage a Wallet?',
    walletUrl3: 'https://tphelp.gitbook.io/en/wallet-management/how-to-manage-my-wallet',
    walletContent4: 'How to Switch a Wallet?',
    walletUrl4: 'https://tphelp.gitbook.io/en/wallet-management/how-to-switch-my-wallet',
    walletContent5: 'How to Sync a Wallet?',
    walletUrl5: 'https://tphelp.gitbook.io/en/wallet-management/how-to-sync-a-wallet',
    transferTitle: 'Transfer Tutorials',
    transferTitle1: 'Advanced Functions',
    transferContent1: 'How to Receive My Assets?',
    transferUrl1: 'https://tphelp.gitbook.io/en/transfer-tutorial/how-to-receive-my-assets',
    transferContent2: 'How to Transfer My Assets to a Wallet?',
    transferUrl2: 'https://tphelp.gitbook.io/en/transfer-tutorial/how-to-transfer-assets-to-the-wallet-exchange',
    transferContent3: 'How to Transfer My Assets to a Exchange?',
    transferUrl3: 'https://tphelp.gitbook.io/en/transfer-tutorial/how-to-transfer-assets-to-the-wallet-exchange',
    transferContent4: 'How to Accelerate My Transaction?',
    transferUrl4: 'https://tphelp.gitbook.io/en/transfer-tutorial/how-to-accelerate-my-transaction',
    transferContent5: 'How to Cancel My Transaction?',
    transferUrl5: 'https://tphelp.gitbook.io/en/transfer-tutorial/how-to-cancel-my-transaction',
    transferContent6: 'How to Add Memo When Transferring?',
    transferUrl6: 'https://tphelp.gitbook.io/en/transfer-tutorial/how-to-add-memo-when-transferring',

    headerUrl: require('../../assets/header_en.png'),
    more: 'More Tutorials',
    moreUrl: 'https://tphelp.gitbook.io/en/',
    basicTitle: 'Basics',
    basicSubtitle: 'Blockchain basic terminology',
    securityTitle: 'Security',
    securitySubtitle: 'Fraud preventions learning',
    testAndAward: 'Test and <span class="earn">Earn</span>',
    testAndAwardDesc: 'Learn wallet knowledge and do a test to get rewards',
    testAndAwardUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSf6RLJeV4eE3XGiqTEHr9meUAiNBDzJvfXF7XfQhNMIJfs19Q/viewform?usp=sf_link'
};

export default en;
